<template>
  <div
    class="list-item"
    :class="{
      current: item.currentCompany === 1,
      fold: item.currentCompany !== 1 && fold,
      expire: isExpired || !item.companyProduct 
    }"
  >
    <div class="title-container" @click.stop="$emit('goDetail', item)">
      <img class="avatar" :src="item.logoImage ? item.logoImage.url : ''" alt="机构logo" />
      <div class="title van-multi-ellipsis--l2">
        {{ item.companyName }}
      </div>
      <span
        class="edit-btn"
        v-if="item.currentCompany !== 1"
        @click.stop="$emit('change', item)"
        :data-test="`base-organization-list-btn-changeOrganization-${item.id}`"
      >
        切换机构
      </span>
    </div>
    <div class="more-info"  @click.stop="$emit('goDetail', item)">
      <div class="info-line">
        <template v-if="item.companyProduct && item.companyProduct.productStatus == 0">
          <span class="gray">已禁用</span>  
        </template>
        <template v-else-if="item.companyProduct">
          <span class="gray" v-if="isExpired">过期时间</span>                    
          <span class="gray" v-if="!isExpired">有效期至</span>
          <span v-if="item.companyProduct.productStatus == 2">{{ item.companyProduct.expireTime | formatDatetime('yyyy-MM-dd') }}</span>
          <span v-if="item.companyProduct.productStatus == 1">{{ item.companyProduct.expireTime | formatDatetime('yyyy-MM-dd') }}(试用)</span>
        </template>  
        <template v-else>
          <span class="gray">未激活</span>
        </template>      
      </div>
      <div class="info-line" v-if="item.openProductNameList && item.openProductNameList.length">
        <span class="gray">其他开通</span>
        <span>{{item.openProductNameList.join('、')}}</span>
      </div>
    </div>

    <div class="operation-container" v-if="item.companyProduct && item.companyProduct.productStatus != 0">
      <div class="operation-btn" v-if="isShiyong" @click.stop="$emit('goto', 0)">开通</div>
      <div class="operation-btn" v-if="!isShiyong" @click.stop="$emit('goto', 1)">续费</div>
      <div class="operation-btn" v-if="!isShiyong && !isExpired && app.permission.op('expansion_campus')" @click.stop="$emit('goto', 2)">校区扩容</div>
      <div class="operation-btn" @click.stop="$emit('edit', item)" v-if="app.permission.op('edit_company')">修改资料</div>
      <div class="operation-btn" @click.stop="$emit('exit', item)" v-if="!app.permission.op('_superAdmin')">退出机构</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'org-card',
  props: ['item'],
  data() {
    return {
      fold: false,
    };
  },
  computed: {
    isShiyong() {
      return this.item.companyProduct && this.item.companyProduct.productStatus == 1;
    },
    isExpired() {
      return this.item.companyProduct && this.item.companyProduct.expired;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.list-item {
  position: relative;
  margin-bottom: calc(var(--gap) * 12);
  background: var(--white);
  border-radius: var(--radius-sm);
  .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
    .avatar {
      flex: 0 0 auto;
      width: calc(var(--w) * 36);
      height: calc(var(--w) * 36);
      overflow: hidden;
      border-radius: 50%;
      border: 1px solid var(--g4);
      margin-right: calc(var(--gap) * 12);
    }
    .title {
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      color: var(--g8);
      font-weight: var(--bold);
      flex: 1 1 auto;
      text-align: left;
    }

    .edit-btn {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: calc(var(--gap) * 5) calc(var(--gap) * 12);
      top: calc(var(--gap) * 16);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--white);
      background: var(--c1);
      border-radius: calc(var(--gap) * 32);
      border: 1px solid var(--g3);
    }
  }
  .more-info {
    padding-bottom: calc(var(--gap) * 12);
    .info-line {
      padding: calc(var(--gap) * 6) calc(var(--gap) * 16);
      color: var(--g8);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      .gray {
        color: var(--g6);
        margin-right: calc(var(--gap) * 18);
      }
    }
  }
  .operation-container {
    width: 100%;
    height: calc(var(--gap) * 52);
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--c1);
    font-weight: var(--bold);
    border-top: 1px solid var(--g3);
    .operation-btn {
      padding: calc(var(--gap) * 8);
    }
  }
  .content {
    display: none;
  }
  &.fold {
    .edit-btn {
      display: none;
    }
    .operation-container {
      display: none;
    }
    .more-info {
      display: none;
    }
  }
  &:not(.current){
    .operation-container{
      display: none;
    }
  }
  &.expire {
    .title-container{
      .avatar, .title{
        opacity: 0.6;
      }
    }
    .more-info {
      opacity: 0.6;
    }
  }
}
.list-item.current {
  border: 1px solid var(--c1);
  overflow: hidden;
  &::before {
    position: absolute;
    top: -1px;
    right: 0px;
    padding: calc(var(--gap) * 4) calc(var(--gap) * 12);
    content: '当前机构';
    width: auto;
    font-size: var(--fs-sm);
    line-height: 1;
    color: var(--white);
    background: var(--c1);
    border-radius: 0px var(--radius-sm) 0 var(--radius-sm);
    z-index: 1;
  }
}
</style>
